import React, { useState, useEffect } from 'react'
import { Card, Button } from 'antd'
import { getDownloadTaskList, downloadExcelV2 } from '@/services/orderQuery/downloadTask'
import AntdTable from '@/components/table/AntdTable'
import { formatMessage, downloadTemplate } from '@/utils/common'
import moment from 'moment'
const dateFormat3 = 'YYYY-MM-DD HH:mm:ss'
const DownloadTaskPage = props => {
  const [tableList, setTableList] = useState([])
  // const [pagination, setPagination] = useState(paginationInit)
  const tableColumns = [
    {
      title: formatMessage('languageObj.downloadTaskLocale.tableCol1'),
      dataIndex: 'idx',
      width: 40,
      render: (text, record, index) => {
        return <div className="word_break_all">{index + 1}</div>
      }
    },
    {
      title: formatMessage('languageObj.downloadTaskLocale.tableCol2'),
      dataIndex: 'id',
      width: 40,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.downloadTaskLocale.tableCol7'),
      dataIndex: 'file_name',
      width: 130,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.downloadTaskLocale.tableCol3'),
      dataIndex: 'create_time',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text && moment(text).format(dateFormat3)}</div>
      }
    },
    {
      title: formatMessage('languageObj.downloadTaskLocale.tableCol4'),
      dataIndex: 'start_time',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text && moment(text).format(dateFormat3)}</div>
      }
    },
    {
      title: formatMessage('languageObj.downloadTaskLocale.tableCol5'),
      dataIndex: 'end_time',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text && moment(text).format(dateFormat3)}</div>
      }
    },
    {
      title: formatMessage('languageObj.downloadTaskLocale.tableCol6'),
      dataIndex: 'ro_is_refunded_text',
      width: 50,
      render: (text, record) => {
        if (record.task_status === 2) {
          return (
            <Button
              className="btn-link"
              onClick={() => {
                downLoadFun(record)
              }}
              type="link"
            >
              {formatMessage('languageObj.commonLocale.download')}
            </Button>
          )
        } else if (record.task_status === 1) {
          return (
            <Button disabled type="link">
              {formatMessage('languageObj.downloadTaskLocale.downloading')}
            </Button>
          )
        } else {
          return (
            <Button disabled type="link">
              {formatMessage('languageObj.downloadTaskLocale.downloadErr')}
            </Button>
          )
        }
      }
    }
  ]
  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const searchDataFun = () => {
    getDownloadTaskList().then(res => {
      const dt = res.resultData || []
      setTableList(dt)
    })
  }
  // 导出结果
  const downLoadFun = record => {
    downloadExcelV2(record.file_name).then(res => {
      downloadTemplate(res.resultData, record.file_name)
    })
  }
  return (
    <div>
      <Card>
        <div className="content-container">
          <div>
            <AntdTable
              title={() => (
                <div>
                  <div className="defaultColor">{formatMessage('languageObj.downloadTaskLocale.tableTitle')}</div>
                </div>
              )}
              dataSource={tableList}
              columns={tableColumns}
              pagination={false}
            />
          </div>
        </div>
      </Card>
    </div>
  )
}
export default DownloadTaskPage
